import { render, staticRenderFns } from "./CoreProductOrderTable.vue?vue&type=template&id=7613a70c&scoped=true"
import script from "./CoreProductOrderTable.vue?vue&type=script&lang=js"
export * from "./CoreProductOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7613a70c",
  null
  
)

export default component.exports